import { Component } from "react";
import { BrowserRouter, Route, Routes, Navigate } from "react-router-dom";
import Main from "./component/Main";
import Login from "./component/Login";
import Equipment from "./component/Equipment";
import NotFound from "./component/NotFound";

export default class RouterSystem extends Component {
  render() {
    return (
      // react-router-dom v5 는 Switch 컴포넌트 활용
      // react-router-dom v6 은 Routes 컴포넌트 활용
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Login />} />
          <Route path="/main" element={<Main />} />
          <Route path="/equipment" element={<Equipment />} />
          {/* 일치하지 않는 경로 접근 방식 */}
          {/* <Route path="*" element={<Navigate to="/" replace />} /> */}
          <Route path="*" element={<NotFound />} />{" "}
        </Routes>
      </BrowserRouter>
    );
  }
}
